import { Appnavigator } from './components/Appnavigation/Appnavigator';

function App() {
  return (
    <Appnavigator/>
  );
}

export default App;
